import { useLanguage } from "@hooks/useLanguage";

export const TablePagination = (
  pagination: {
    total: number;
    size: number;
    page: number;
  },
  handleQuery: (key: string, value: any) => void,
) => {
  const { language } = useLanguage();
  const { page, size, total } = pagination || {};

  return {
    totalPage: Math.ceil(total / size),
    onClick: (currentPage: number) => handleQuery("page", currentPage),
    activePage: page,
    language: language as any,
  };
};
